import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {STI_TELECONSULTATION_KEYS} from '~/constants/medical-questionnaires';
import {useNotification} from '~/hooks';
import Questionnaire1Screen from '~/pages/homes/sti-teleconsultation/Questionnaire1Screen';
import Questionnaire2Screen from '~/pages/homes/sti-teleconsultation/Questionnaire2Screen';
import Questionnaire3Screen from '~/pages/homes/sti-teleconsultation/Questionnaire3Screen';
import Questionnaire4Screen from '~/pages/homes/sti-teleconsultation/Questionnaire4Screen';
import Questionnaire5Screen from '~/pages/homes/sti-teleconsultation/Questionnaire5Screen';
import {RootState} from '~/redux/root-reducer';
import {AppDispatch} from '~/redux/root-store';
import {trackPageViewGA} from '~/services/google-analytics';

const STITeleconsultation = () => {
  const dispatch: AppDispatch = useDispatch();
  const {addMessage} = useNotification(dispatch);
  const activeQuestion = useSelector((state: RootState) => state.questionnaires.activeQuestion);
  const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);

  const questionnaires = medicalQuestionnaire?.questionnaires;

  if (!questionnaires?.length) return null;

  const renderQuestion = () => {
    const keys = activeQuestion.keys;
    const key = keys[keys.length - 1];
    switch (key) {
      case STI_TELECONSULTATION_KEYS.START:
        trackPageViewGA('/sti-teleconsultation/start', 'MDQ-STI Teleconsultation - Start');
        return <Questionnaire1Screen />;
      case STI_TELECONSULTATION_KEYS.PROFILE:
        trackPageViewGA('/sti-teleconsultation/profile', 'MDQ-STI Teleconsultation - Profile');
        return <Questionnaire2Screen />;
      case STI_TELECONSULTATION_KEYS.INVALID:
        trackPageViewGA('/sti-teleconsultation/invalid', 'MDQ-STI Teleconsultation - Invalid');
        return <Questionnaire3Screen />;
      case STI_TELECONSULTATION_KEYS.STATEMENT_BEST_APPLIES:
        trackPageViewGA(
          '/sti-teleconsultation/statement-best-applies',
          'MDQ-STI Teleconsultation - Statement Best Applies',
        );
        return <Questionnaire4Screen />;
      case STI_TELECONSULTATION_KEYS.MORE_INFORMATION:
        trackPageViewGA('/sti-teleconsultation/more-information', 'MDQ-STI Teleconsultation - More Information');
        return <Questionnaire5Screen />;
      default:
        // eslint-disable-next-line no-console
        console.warn('Not implement yet!');
        return <Questionnaire1Screen />;
    }
  };

  return renderQuestion();
};

export default STITeleconsultation;
